<script setup>
import {Head, Link} from '@inertiajs/vue3';
import BaseButton from "@/Components/UI/buttons/BaseButton.vue";
import {ref} from "vue";
import BaseInputDynamic from "@/Components/UI/inputs/BaseInputDynamic.vue";
import PublicPageLayout from "@/Layouts/PublicPageLayout.vue";
import AuthenticationContainer from "@/Pages/Auth/Partial/AuthenticationContainer.vue";
import BaseInputPassword from "@/Components/UI/inputs/BaseInputPassword.vue";
import QualifiedSignatureLogin from "@/Pages/Auth/Partial/QualifiedSignatureLogin.vue";
import {useSubmittableForm} from "@/Composables/useSubmittableForm";

defineProps({
    canResetPassword: {
        type: Boolean,
    },
    status: {
        type: String,
    },
});

const disabled = ref(false);

const {form, submit} = useSubmittableForm(
    {
        username: '',
        password: '',
        remember: true,
    },
    {
        url: route('login'),
        preserveScroll: false,
        options: {
            onFinish: () => {
                disabled.value = false;
                form.reset('password');
            },
        },
    },
);

const onSubmit = () => {
    disabled.value = true;
    form.username = form.username.toLowerCase();
    submit();
};
</script>

<template>
    <Head title="Вход"/>
    <PublicPageLayout>
        <AuthenticationContainer>
            <template #title>Добро пожаловать!</template>
            <template #content>
                <form class="w-full"
                      @submit.prevent="onSubmit">
                    <p class="text-sm text-dark-light mb-5">
                        Войдите в сервис или зарегистрируйтесь
                    </p>
                    <div class="mb-5 text-left">
                        <BaseInputDynamic v-model="form.username"
                                          :error="form.errors.username"
                                          autocomplete="username"
                                          autofocus
                                          label="Телефон или email"
                                          v-tooltip.top="'Укажите данные, использованные при регистрации'"
                                          required/>
                    </div>

                    <div class="mb-5 text-left">
                        <BaseInputPassword v-model="form.password"
                                           :error="form.errors.password"
                                           autocomplete="current-password"
                                           v-tooltip.top="'Пароль от вашей учетной записи'"
                                           required/>
                    </div>

                    <BaseButton variant="primary"
                                       :disabled="disabled"
                                       class="w-full mb-5"
                                       type="submit">
                        Войти
                    </BaseButton>

                    <QualifiedSignatureLogin v-model:disabled="disabled"/>

                    <p v-if="canResetPassword"
                       class="text-dark-light text-xs md:text-base">
                        Не можете войти?
                        <Link :href="route('password.request')"
                              class="text-blue-1">
                            Восстановить пароль
                        </Link>
                        <br>
                        или
                        <Link :href="route('register')"
                              class="text-blue-1">
                            Создать аккаунт
                        </Link>
                    </p>
                </form>
            </template>
        </AuthenticationContainer>
    </PublicPageLayout>
</template>
